import memoizee from 'memoizee'
import moment from 'moment'

import { dropTimeZoneFromDate } from 'shared/libraries/utils/date'
import {
  changeTimezone,
  simplerGetTimeOfDayFromDate,
} from 'shared/libraries/utils/date'

/**
 * NOTE: Copied from oppizi-api/src/libraries/utils/date
 * Get the week number e.g first new week in Jan is 1, last week in December
 * is 52.
 * Taken and modified from https://stackoverflow.com/a/6117889/837649
 * @param {Date} d
 * @returns {number} 1 to 53
 */
export const getWeekNumber = memoizee(d => {
  return moment(d).isoWeek()
})

/**
 * NOTE: Copied from oppizi-api/src/libraries/utils/date
 * Converts 1 to W01 and 30 to W30
 * @param {num}
 * @returns {string}
 */
export const formatWeekNumber = memoizee(num => {
  num = num + ''
  if (num.length === 1) num = '0' + num
  return 'W' + num
})

/**
 * Given a iso date with a timezone, this will simply drop the timezone off the
 * end so that if you instanciate it with `new Date(dateStr)` it won't do any
 * timezone manipulation and you'll have a date object that's local to that
 * timezone. Will return the same date if it is missing timezone
 * @returns {string}
 */
export const processDate = date => {
  try {
    const result = dropTimeZoneFromDate(date)
    return result
  } catch (e) {
    return date
  }
}

export const getCurrentTimeOfDay = ({
  afternoonCheckInTime,
  lunchCheckInTime,
  timezone,
}) => {
  if (!afternoonCheckInTime || !lunchCheckInTime || !timezone) {
    return
  }
  const date = new Date().toISOString()
  const dateStr = changeTimezone(date, timezone)
  const dropTimezone = dropTimeZoneFromDate(dateStr)
  return simplerGetTimeOfDayFromDate(dropTimezone, {
    afternoonCheckInTime,
    lunchCheckInTime,
  })
}

/**
 * Validates that the input string is a valid date formatted as "mm/dd/yyyy" in US and "dd/mm/yyyy" in Other Countries
 */
export const isValidDate = (dateString, isUSFormat = false) => {
  if (!isNaN(dateString)) return true

  const dateStrings = dateString.split(' ')
  if (!/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(dateStrings[0])) return false

  const parts = dateStrings[0].split('/')
  if (parts.length !== 3) return false

  const day = isUSFormat ? parseInt(parts[1], 10) : parseInt(parts[0], 10)
  const month = isUSFormat ? parseInt(parts[0], 10) : parseInt(parts[1], 10)
  const year = parseInt(parts[2], 10)

  if (year < 1000 || year > 3000 || month == 0 || month > 12) return false

  const monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]

  if (year % 400 == 0 || (year % 100 != 0 && year % 4 == 0)) monthLength[1] = 29

  return day > 0 && day <= monthLength[month - 1]
}

/**
 * get UNIX Timestamp
 */
export const getUNIXTimestamp = (timestamp, isUSFormat = false) => {
  // if timestamp is Number, we consider this is UNIX timestamp
  if (!isNaN(timestamp)) return Number(timestamp)

  const d = isUSFormat
    ? moment.utc(timestamp, 'MM/DD/YYYY HH:mm:ss')
    : moment.utc(timestamp, 'DD/MM/YYYY HH:mm:ss')
  return d.isValid() ? d.unix() : null
}

/**
 * Checks if a Moment is valid, returns fallback if it isn't
 * @param {moment.Moment} m
 * @param {moment.Moment} fallback
 */
export function validMoment(m, fallback) {
  if (m.isValid()) {
    return m
  }
  return fallback
}
